/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetMeDocument = gql`
    query GetMe {
  me {
    userName
    roles
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const UserDocument = gql`
    query User {
  user {
    id
    email
    activePremium
    admin
    domains {
      countDomainPages
    }
    userPremium {
      userPremiumEndDate
      trialActive
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const GeoDataDocument = gql`
    query GeoData {
  geoData {
    latitude
    longitude
    city
    country
    countryIsoCode
  }
}
    `;

/**
 * __useGeoDataQuery__
 *
 * To run a query within a React component, call `useGeoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeoDataQuery(baseOptions?: Apollo.QueryHookOptions<GeoDataQuery, GeoDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoDataQuery, GeoDataQueryVariables>(GeoDataDocument, options);
      }
export function useGeoDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoDataQuery, GeoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoDataQuery, GeoDataQueryVariables>(GeoDataDocument, options);
        }
export function useGeoDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GeoDataQuery, GeoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeoDataQuery, GeoDataQueryVariables>(GeoDataDocument, options);
        }
export type GeoDataQueryHookResult = ReturnType<typeof useGeoDataQuery>;
export type GeoDataLazyQueryHookResult = ReturnType<typeof useGeoDataLazyQuery>;
export type GeoDataSuspenseQueryHookResult = ReturnType<typeof useGeoDataSuspenseQuery>;
export type GeoDataQueryResult = Apollo.QueryResult<GeoDataQuery, GeoDataQueryVariables>;
export type GetMeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'SymfonyUserImpl', userName: string, roles: Array<string> } | { __typename?: 'User', userName: string, roles: Array<string> } | null };

export type UserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'GraphUser', id?: number | null, email?: string | null, activePremium: boolean, admin: boolean, domains: Array<{ __typename?: 'GraphDomain', countDomainPages: number }>, userPremium?: { __typename?: 'GraphUserPremium', userPremiumEndDate?: any | null, trialActive: boolean } | null } | null };

export type GeoDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GeoDataQuery = { __typename?: 'Query', geoData: { __typename?: 'GraphGeo', latitude?: number | null, longitude?: number | null, city?: string | null, country?: string | null, countryIsoCode?: string | null } };
